import type { PostedOrder } from "~/features/posted-orders/types";

type PostedOrderFailedPanelProps = Readonly<{
  item: PostedOrder;
  onClose: () => void;
  onRetry: () => void;
  retrying?: boolean;
}>;

export function PostedOrderFailedPanel({
  item,
  onClose,
  onRetry,
  retrying = false,
}: PostedOrderFailedPanelProps) {
  const failedResponse = item.navError ?? "Post to NAV failed for this order.";

  return (
    <div
      style={{
        background: "white",
        borderRadius: 8,
        border: "1px solid var(--border)",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        height: "fit-content",
        maxHeight: "calc(100vh - 200px)",
        position: "relative",
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          background: "rgba(255, 255, 255, 0.9)",
          border: "1px solid var(--border)",
          borderRadius: "50%",
          width: 28,
          height: 28,
          fontSize: 18,
          cursor: "pointer",
          color: "var(--text-muted)",
          padding: 0,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10,
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}
        aria-label="Close"
      >
        ×
      </button>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <div style={{ padding: 16, overflow: "auto", flex: 1 }}>
          <h4 style={{ margin: "0 0 12px 0", fontSize: 16, fontWeight: 600 }}>
            Failed order — {item.smNumber}
          </h4>
          <p style={{ margin: "0 0 8px 0", fontSize: 13, fontWeight: 600 }}>
            Failed response
          </p>
          <pre
            style={{
              margin: "0 0 16px 0",
              padding: 12,
              fontSize: 12,
              background: "var(--neutral-gray)",
              borderRadius: 6,
              overflow: "auto",
              maxHeight: 160,
              border: "1px solid var(--border)",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {failedResponse}
          </pre>
          <p style={{ margin: 0, fontSize: 12, color: "var(--text-muted)" }}>
            Click Retry to post this order to NAV again.
          </p>
        </div>

        <div
          style={{
            padding: 16,
            borderTop: "1px solid var(--border)",
            display: "flex",
            gap: 8,
            justifyContent: "flex-end",
          }}
        >
          <button
            className="secondary"
            onClick={onClose}
            style={{ padding: "10px 20px" }}
          >
            Close
          </button>
          <button
            className="primary"
            onClick={onRetry}
            disabled={retrying}
            style={{ padding: "10px 20px", cursor: retrying ? "wait" : "pointer", opacity: retrying ? 0.7 : 1 }}
          >
            {retrying ? "Retrying..." : "Retry"}
          </button>
        </div>
      </div>
    </div>
  );
}
